import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class VersionWatcherService {
    private http = inject(HttpClient);
    private currentVersion?: string;

    start(): void {
        this.loadVersion();

        setInterval(() => {
            this.http.get<{ version: string }>('/version.json', { params: { t: Date.now() } })
                .subscribe(v => {
                    if (this.currentVersion && v.version !== this.currentVersion) {
                        location.reload();
                    }
                });
        }, 3 * 60 * 1000);
    }

    private loadVersion() {
        this.http.get<{ version: string }>('/version.json', { params: { t: Date.now() } })
            .subscribe(v => this.currentVersion = v.version);
    }
}
